export default __webpack_public_path__ + "static/media/loader-white.a6aee69c.svg";